export const DEFAULT_MEMBERSHIP_BILLING_MAX_ATTEMPTS = 3;

const normalizedMembershipStatus = (membership) => String(membership && membership.status || "").trim().toLowerCase();

export const membershipBillingAlertDetails = (membership) => {
	const failedAttempts = Math.max(0, parseInt(membership && membership.failed_billing_count, 10) || 0);
	const configuredMaxAttempts = parseInt(membership && membership.billing_max_failed_attempts, 10);
	const maxAttempts = Number.isFinite(configuredMaxAttempts) && configuredMaxAttempts > 0
		? configuredMaxAttempts
		: DEFAULT_MEMBERSHIP_BILLING_MAX_ATTEMPTS;
	const status = normalizedMembershipStatus(membership);
	const deleted = ["deleting", "deleted"].indexOf(status) !== -1;
	const cancelled = !deleted && (
		!!(membership && membership.cancelled_at)
		|| ["canceled", "cancelled"].indexOf(status) !== -1
	);
	const alertType = cancelled ? "cancelled" : (failedAttempts > 0 && !deleted ? "failed" : null);

	return {
		alertType,
		cancelledAt: membership && membership.cancelled_at || null,
		failedAttempts,
		lastFailedBillingAt: membership && membership.last_failed_billing_at || null,
		maxAttempts,
		nextBillingAttemptAt: membership && membership.next_bill_date || null,
		remainingAttempts: Math.max(0, maxAttempts - failedAttempts),
		show: alertType !== null,
	};
};
